import { useFieldArray, useForm } from "react-hook-form";
import Form from "./Form";
import { tw } from "@careinfo/tailwind";
import Card from "../Reusable/Card";
import Button from "../Reusable/Button";
import Modal from "../Reusable/Modal";
import { getKey } from "../../helpers/sessionKey";
import { yupResolver } from "@hookform/resolvers/yup";
import { CreateDailyNoteValidationForm } from "../../validation/DailyNote/DailyNoteSchem";

const CreateDailyNote = (props: any) => {
  const {
    handleCreate,
    isLoading,
    defaultBranch,
    data,
  } = props;
  const defaultBranchParseValue = JSON.parse(defaultBranch);
  const {
    control,
    register,
    handleSubmit,
    getValues,
    reset,
    watch,
    setError,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    resolver:yupResolver(CreateDailyNoteValidationForm),
    defaultValues: async () => {
      return {
        items: [
          {
            description: null,
            credit: null,
            debit:null,
          },
        ],
      };
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

 
  const isSuperUser = getKey("is_superuser") === "true";
  return (
    <>
      <Card>
        <form
          className={tw``}
          onSubmit={handleSubmit((data) => handleCreate(data, false, setError))}
        >
          <Form
            errors={errors}
            register={register}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            fields={fields}
            isSuperUser={isSuperUser}
            watch={watch}
            remove={remove}
            append={append}
          />
          <div className={tw`flex justify-end w-full gap-x-4 px-4`}>
            <div className={tw`w-32`}>
              <Button label={"Add To Draft"} isLoading={isLoading} />
            </div>
          </div>
        </form>
      </Card>
    </>
  );
};

export default CreateDailyNote;

